/**
 * useLanguageFromUrl
 *
 * Hook que mantém o idioma do i18n sincronizado com o parâmetro de URL
 * `?language=<lang>` de forma reativa.
 *
 * Deve ser montado **dentro** do <BrowserRouter> para ter acesso ao
 * `useSearchParams` do react-router-dom.
 *
 * Exemplo de uso:
 *   // No componente raiz dentro do BrowserRouter:
 *   useLanguageFromUrl();
 *
 * Comportamento:
 *  - Quando `?language=en-US` está na URL  → troca para en-US
 *  - Quando `?language=pt-BR` está na URL  → troca para pt-BR
 *  - Quando o parâmetro está ausente       → mantém o idioma atual (sem reset)
 *  - Idioma não suportado                  → ignora silenciosamente
 */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import i18n from "./index";

const SUPPORTED_LANGS = ["pt-BR", "pt-PT"];

export function useLanguageFromUrl() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const lang = searchParams.get("language");

    if (!lang) return;
    if (!SUPPORTED_LANGS.includes(lang)) {
      if (process.env.NODE_ENV === "development") {
        console.error(
          `[i18n] Idioma "${lang}" não suportado. Idiomas disponíveis: ${SUPPORTED_LANGS.join(", ")}`,
        );
      }
      return;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [searchParams]);
}
